/* 🤖 this file was generated by svg-to-ts */
export const matIconWifi1Bar: {
  name: 'wifi-1-bar';
  data: string;
} = {
  name: 'wifi-1-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.53 17.46 12 21l-3.53-3.54c.9-.9 2.15-1.46 3.53-1.46s2.63.56 3.53 1.46z"/></svg>`
};
